import { useTranslation } from "react-i18next";
import { useStats } from "react-instantsearch";

import themeColors from "../../constants/themeColors";

export default function InstantSearchNumberOfHits() {
	const { nbHits } = useStats();
	const { t } = useTranslation();

	return (
		<span style={{ whiteSpace: "nowrap", color: themeColors.GREY, fontSize: 13 }}>
			{t("numHits", "{{num}} hits", { num: nbHits })}
		</span>
	);
}
